import useSWR from 'swr';
import { postFetcher } from '../../swr/fetchers';
import { HookOptionsTypes } from '../../types/HookOptionsTypes';

export type SpreedlySessionData = {
  nonce: string;
  timestamp: number;
  certificateToken: string;
  signature: string;
};

const SPREEDLY_SESSION_ENDPOINT = '/v1/payment-methods/sign';

// Stable fetcher reference - defined outside the hook to avoid recreation on every render
const spreedlySessionFetcher = postFetcher();

/**
 * Fetch Spreedly session/certificate data for payment form initialization.
 * This is a POST request to /v1/payment-methods/sign.
 *
 * Note: This endpoint does not require authentication.
 *
 * @param options - Optional SWR hook options.
 * @returns The Spreedly session data including nonce, timestamp, certificateToken, and signature.
 */
export const useSpreedlySession = ({
  skip = false,
  ...options
}: HookOptionsTypes = {}) => {
  // SWR key: [url, payload, token]
  // Token is empty string since this endpoint doesn't require authentication
  const swrKey = skip
    ? null
    : [SPREEDLY_SESSION_ENDPOINT, JSON.stringify({}), ''];

  return useSWR<SpreedlySessionData>(swrKey, spreedlySessionFetcher, {
    ...options,
  });
};

export default useSpreedlySession;
